import React, { FC } from "react";

interface SizeFilterSearchHeaderProps {
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearchClear: () => void;
  placeholder?: string;
  label?: string;
}

const SizeFilterSearchHeader: FC<SizeFilterSearchHeaderProps> = ({
  searchValue,
  onSearchChange,
  onSearchClear,
  placeholder,
  label
}) => {
  return (
    <div className="search-wrapper">
      <input
        type="text"
        placeholder={placeholder || "Search in Size"}
        value={searchValue}
        onChange={onSearchChange}
        aria-label={`Search for ${label}`}
      />
      <span className="search_icon" />
      {searchValue && <span className="cross_icon" onClick={onSearchClear} />}
    </div>
  );
};

export default SizeFilterSearchHeader;
